import { INCOTERM_OPTIONS } from '@klear/constants/options'
import type {
  PurchaseOrderFieldChange,
  PurchaseOrderForm,
  PurchaseOrderFormErrorMap
} from '@klear/purchase-order/wire.client'
import { MoneyInput } from '@klear/ui/components/money-input'
import { Combobox } from '@klear/ui/components/combobox'
import { Input } from '@klear/ui/components/input'
import { Label } from '@klear/ui/components/label'
import { Textarea } from '@klear/ui/components/textarea'
import { DatePicker } from '@klear/ui/components/date-picker'

interface PurchaseOrderFieldsProps {
  values: PurchaseOrderForm
  errors: PurchaseOrderFormErrorMap
  onFieldChange: PurchaseOrderFieldChange
}

function FieldError({ message }: { message?: string }) {
  return message ? <p className="text-sm text-destructive">{message}</p> : null
}

export function PurchaseOrderFields({ values, errors, onFieldChange }: PurchaseOrderFieldsProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="text-sm font-medium">PO Number</Label>
          <Input value={values.number} onChange={(e) => onFieldChange('number', e.target.value)} />
        </div>
        <div className="space-y-2">
          <Label className="text-sm font-medium">Incoterm</Label>
          <Combobox
            value={values.incoterm}
            options={[...INCOTERM_OPTIONS]}
            placeholder="Search incoterms…"
            triggerLabel="Select incoterm…"
            onChange={(v) => onFieldChange('incoterm', v)}
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <MoneyInput value={values.amount} onChange={(m) => onFieldChange('amount', m)} errorMessage={errors.amount} />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="text-sm font-medium">Issue Date</Label>
          <DatePicker value={values.effectiveDate} onChange={(date) => date && onFieldChange('effectiveDate', date)} />
        </div>
        <div className="space-y-2">
          <Label className="text-sm font-medium">Target Delivery Date</Label>
          <DatePicker value={values.endDate} onChange={(date) => date && onFieldChange('endDate', date)} />
          <FieldError message={errors.endDate} />
        </div>
      </div>
      <div className="space-y-2">
        <Label className="text-sm font-medium">Notes</Label>
        <Textarea value={values.notes} onChange={(e) => onFieldChange('notes', e.target.value)} />
      </div>
    </div>
  )
}
